import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConversationalWorkflowDetailForNRO = lazy(() =>
  import("@scenes/ConversationalWorkflowDetail").then((module) => ({
    default: module.ConversationalWorkflowDetail,
  }))
);

export const conversationalWorkflowEditNRO: NavigationRoutingObject = {
  Component: ConversationalWorkflowDetailForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("conversational-workflow-edit-nro-heading", "Edit Conversational Workflow"),
  pageNameForTracking: () => "Edit Conversational Workflow",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("agent_console_conversational");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/conversational/:appGroupId",
};
